import { Card, CardContent } from '@mui/material'
import { Box } from '@mui/system'
import { ReactComponent as ArrowOpenDone } from 'assets/arrow_open_logo.svg'

import { NavLink } from 'react-router-dom'
import { TypographyHeader } from 'ui/typography/TypographyHeader'

const FarmFillCard = props => {
	return (
		<NavLink to={`${props.id}`}>
			<Card
				sx={{
					mt: '24px',
					borderRadius: '12px',
					boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
					'&:hover': { boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.15)' },
				}}
			>
				<CardContent>
					<Box
						display='flex'
						flexDirection='row'
						alignItems='center'
						justifyContent='space-between'
						sx={{ pt: '8px' }}
					>
						<Box display='flex' flexDirection='row' alignItems='center'>
							<TypographyHeader>{props.title}</TypographyHeader>
						</Box>
						<ArrowOpenDone style={{ rotate: '90deg' }} />
					</Box>
				</CardContent>
			</Card>
		</NavLink>
	)
}

export default FarmFillCard
